'use client';

import styled from 'styled-components';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled.div`
  display: flex;
  width: 100%;

  border-radius: 16px;
  border: 1px solid ${colors.gray3};
  transition: all 0.4s ease;

  .arrow {
    transition: all 0.4s ease;
  }

  &:hover {
    cursor: ${({ $clickable }) => ($clickable ? 'default' : 'pointer')};
    box-shadow: ${({ $clickable }) =>
      $clickable ? '' : 'rgba(99, 99, 99, 0.4) 0px 4px 12px 2px;'};

    .arrow {
      transform: ${({ $clickable }) => ($clickable ? 'none' : 'translateX(-10px) scale(1.3)')};
    }
  }

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    align-items: center;

    max-width: 300px;
  }
`;

export const ImageWrap = styled.div`
  width: 172px;
  height: 172px;

  & > img {
    border-radius: 16px 0 0 16px;
  }

  @media (max-width: ${breakpoints.laptop}) {
    width: auto;
    height: 100%;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;

    & > img {
      width: 100%;
      max-height: 100%;

      border-radius: 16px 16px 0 0;
    }
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;

  flex: 1;
  padding: 16px;
  gap: 16px;
`;

export const Heading = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Qualifications = styled.div`
  color: ${colors.blue};
`;

export const Biography = styled.p`
  font-weight: 300;
  line-height: 1.2;
  text-align: justify;

  ${({ $unabridged }) =>
    !$unabridged &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
      -webkit-line-clamp: 4;
    line-clamp: 4;
      -webkit-box-orient: vertical;`}

  @media (max-width: ${breakpoints.tablet}) {
    font-size: 0.9rem;
  }
`;

export const Name = styled.div`
  font-size: 1.2rem;
  font-weight: 500;
`;
